module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAABLNDRJNTVQODhLNTVLMzNLNDRJNDRLMzNLNDRKMzNKNDRLNDRLNDRKMzNKMzNKMzNAMDBLMzNLMzNKNDRMMzNJMzNQMDBLNDRwtu51AAAAGHRSTlMAvyAgn69AMN/PkIBf79+gcBDvn39QUBDNL045AAAA60lEQVRYw+3YyQ6DIBCAYaSyCIpLXeb9n7TeGqAMY2LSppn/OuZDjBcQ3A8kC11CzNpBsc5RMamg0pNE7QtUs3vd6YFUX3MM0BpMBbJAzM6oMwE5T3+hziTb7qLNYY6O1jT4WCOQj57MvoKMxhMCxb+iS8drNG4RqIGopo1KpgqH6DUMMcQQQwwxxBBDDP0b5DY93gFN7xMBHRo/PF5cokUgB1muuIRHIF1cV0GWFkgDpA2zOJM2GwSB5SFLndKhrp4hjwBZVrULZAX6URRP3nk4xttCnVm0ICRH0gUCiXLYlYbPGLRHIcF9vxfqv+RT2vL2aQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone_bondo.png
// module id = p3HD
// module chunks = 1